module.exports = __webpack_public_path__ + "static/media/finalmap.830bc435.png";